import FilterForm from 'components/forms/FilterForm';
import { Form, FormProps, Input } from 'antd';
import { InputMask } from 'components/form-items/InputMask';
import { SearchOutlined } from '@ant-design/icons';
import { getTenant } from 'services/tenants';

export interface IUsersFilterForm {
  name: string;
  email: string;
  cpf: string;
  by_grandparent_type: 'Course' | 'Graduate::Discipline';
  by_grandparent_id: string;
  estacio_id: string;
}

interface UsersFilterFormProps {
  searchFormProps: FormProps<IUsersFilterForm>;
}

export const UsersListFilter = ({ searchFormProps }: UsersFilterFormProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="name">
        <Input
          placeholder="Nome do aluno"
          className="min-w-[300px]"
          suffix={<SearchOutlined />}
        />
      </Form.Item>

      <Form.Item name="email">
        <Input placeholder="E-mail do aluno" className="min-w-[300px]" />
      </Form.Item>

      <Form.Item name="cpf">
        <InputMask mask="000.000.000-00" placeholder="CPF do aluno" />
      </Form.Item>

      {getTenant().project === 'morpheus' && (
        <Form.Item name="estacio_id">
          <Input placeholder="ID externo do aluno" />
        </Form.Item>
      )}
    </FilterForm>
  );
};
